export const mixpanelEvents = {
  FORM_SUBMIT: 'form_submit',
  FORM_LANDED: 'form_landed',
  PUBLISH_NEW_FORM: 'publish_new_form',
};
